<template>
	<div>Afronden</div>
</template>

<script lang="ts" setup></script>
